import { useNavigate } from 'react-router';

import { catalogueTitlePath } from '../../api/client';
import type { CatalogueEntry } from '../../api/types';
import { useDiscoveryState } from '../../api/useDiscoveryState';

/// What opening a catalogue tile does.
///
/// Where everything plays on demand, a tile is a title like any other and opens its own page -
/// there is nothing to decide first. Otherwise it opens the dialog that decides between playing
/// what is held and fetching what is not.
export function useOpenCatalogueEntry(openDialog: (entry: CatalogueEntry) => void) {
  const navigate = useNavigate();
  const { playsOnDemand } = useDiscoveryState();

  return (entry: CatalogueEntry) => {
    if (playsOnDemand) {
      void navigate(catalogueTitlePath(entry.title));
    } else {
      openDialog(entry);
    }
  };
}
